import {
  CheckInInstructions,
  Lodging,
  RoomInfoProducts,
  TrackingProperties,
} from "@b2bportal/lodging-api";
import { CallState, LodgingShopSteps } from "@hopper-b2b/types";
import { actionTypes, actions } from "../actions";

export interface ILodgingShopState {
  selectedLodging?: Lodging;
  rooms: RoomInfoProducts[];
  shopTrackingProperties: TrackingProperties;
  checkInInstructions?: CheckInInstructions;
  checkInPolicies?: CheckInInstructions["policies"];
  selectedRoom?: RoomInfoProducts;
  selectedRoomRateId?: string;
  currentStep: LodgingShopSteps;
  selectedOfferOpaque?: string;
  shopCallState: CallState;
  roomsCallState: CallState;
  lodgingPriceChange?: { price_change: number };
}

const initialState: ILodgingShopState = {
  currentStep: LodgingShopSteps.LODGING_DETAILS,
  rooms: [],
  shopTrackingProperties: {},
  shopCallState: CallState.NotCalled,
  roomsCallState: CallState.NotCalled,
  lodgingPriceChange: { price_change: 0 },
};

export function reducer(
  state: ILodgingShopState = initialState,
  action: actions.LodgingShopActions
): ILodgingShopState {
  switch (action.type) {
    case actionTypes.SET_SELECTED_LODGING:
      return {
        ...state,
        selectedLodging: action.lodging,
        selectedOfferOpaque: action.offerOpaque,
        shopCallState: CallState.Success,
      };
    case actionTypes.SET_CHECK_IN_INSTRUCTIONS:
      return {
        ...state,
        checkInInstructions: action.checkInInstructions,
      };
    case actionTypes.SET_CHECK_IN_POLICIES:
      return {
        ...state,
        checkInPolicies: action.checkInPolicies,
      };
    case actionTypes.SET_ROOMS:
      return {
        ...state,
        roomsCallState: CallState.Success,
        rooms: [...action.rooms],
      };
    case actionTypes.SET_SHOP_TRACKING_PROPERTIES:
      return {
        ...state,
        shopTrackingProperties: action.trackingProperties,
      };
    case actionTypes.SET_SELECTED_ROOM:
      return {
        ...state,
        selectedRoom: action.room,
        selectedRoomRateId: action.room?.products?.[0]?.rateId.value,
      };
    case actionTypes.SET_SELECTED_RATE:
      return {
        ...state,
        selectedRoomRateId: action.rateId,
      };
    case actionTypes.SET_CURRENT_SHOP_STEP:
      return {
        ...state,
        currentStep: action.step,
      };

    case actionTypes.SET_SHOP_CALL_STATE:
      return {
        ...state,
        shopCallState: !action.roomsOnly
          ? action.callState
          : state.shopCallState,
        roomsCallState: action.callState,
      };
    case actionTypes.SET_SHOP_PRICE_CHANGE:
      return {
        ...state,
        lodgingPriceChange: { price_change: action.shopPriceChange },
      };
    default:
      return state;
  }
}
